import React from 'react';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class OtherEquipmentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getOtherEquipmentData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      power_required,
      description,
      image,
    } = this.props.otherEquipment;
    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="other-equipment-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('other equipment name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="other-equipment-power-required"
          field="power_required"
          type="number"
          label={<span>{t('power (W)')}</span>}
          placeholder="800"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="other-equipment-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

OtherEquipmentDetail.defaultProps = {
  otherEquipment: {},
};

export default translate('translations', { withRef: true })(OtherEquipmentDetail);



// WEBPACK FOOTER //
// ./src/components/other_equipments/OtherEquipmentDetail.js